let sectionManager = require('./customizer/sections');

$(document).ready(function ($) {

    let saveTable = $('.saveTable');

    saveTable.on('click', function (e) {
        e.preventDefault();
        let currentItem = $(this);
        let sections = $('.builder-main').find('.fieldsSection');
        let fields = $('.fieldsSection').find('.fieldItem'),
            errors = false;

        let tableData = {
            sections: [],
            fields: [],
            _token: $('[name="csrf-token"]').prop('content')
        };

        sections.each(function () {
            let hidden_fields = $(this).data('hidden-fields'),
                visible_fields = $(this).data('visible-fields'),
                column_tabs = $(this).data('column-tabs'),
                name = $(this).data('section-name'),
                related = $(this).data('related-section'),
                section_label = $(this).data('section-label'),
                filter = $(this).data('filter'),
                related_to = $(this).data('related-to'),
                primary_key = $(this).attr('data-primary-key'),
                allow_edit = $(this).data('allow-edit'),
                disable_related_hyperlink = $(this).data('disable-related-hyperlink'),
                enable_counter = $(this).data('enable-counter'),
                allow_scroll = $(this).data('allow-scroll'),
                full_text = $(this).data('full-text'),
                no_of_records = $(this).data('no-of-records'),
                save_keys = $(this).attr('data-save-keys'),
                id = $(this).data('section-id'),
                visibility = $(this).find('.section-visibility').data('visibility');

            if (related && !primary_key) {
                showAlert(`Please add primary keys for section ${section_label}`, 'alert-danger');
                errors = true;
            }

            if(name === 'emails' && !primary_key && visibility === 1){
                showAlert(`Please add primary keys for section ${section_label}`, 'alert-danger');
                errors = true;
            }

            tableData.sections.push({
                label: $(this).data('section-label'),
                sname: $(this).data('section-name'),
                order: $(this).data('section-order'),
                related: $(this).data('related-section'),
                related_to: related_to ? related_to : 0,
                filter: filter ? filter : '',
                visible_fields: visible_fields ? visible_fields : '',
                hidden_fields: hidden_fields ? hidden_fields : '',
                column_tabs: column_tabs ? column_tabs : [],
                primary_key: primary_key ? primary_key : '',
                save_keys: save_keys ? save_keys : '',
                id: id,
                allow_edit: allow_edit,
                disable_related_hyperlink: disable_related_hyperlink,
                enable_counter: enable_counter,
                allow_scroll: allow_scroll,
                no_of_records: no_of_records,
                full_text: full_text,
            });
        });

        if (errors) {
            return;
        }

        fields.each(function () {
            let id,
                name,
                hint,
                description,
                unique,
                capital,
                slVals,
                required,
                nonzero,
                scanner,
                defOpt,
                opLabel,
                opVal,
                isRelated,
                relatedId,
                related_type,
                pattern,
                height,
                width,
                related_fields = '',
                label,
                primary_column = '',
                filter_column = '',
                related_filter = '',
                color_options = '',
                mappings = '',
                primary_keys = '',
                alert_type = '',
                event_field = '',
                event_option = '',
                view_only = '',
                speech_to_text = '',
                pattern_enabled = '',
                auto_field_type = '',
                automation_id = '',
                message = '',
                btn_color = '',
                btn_text_color = '',
                section = $(this).parents('.fieldsSection').data('section-name');

            if (typeof $(this).data('name') !== 'undefined') {

                if ($(this).data('hint') && $(this).data('hint').length) {
                    hint = $(this).data('hint');
                } else {
                    hint = $(this).attr('data-hint');
                }

                if ($(this).data('description') && $(this).data('description').length) {
                    description = $(this).data('description');
                } else {
                    description = $(this).attr('data-description');
                }

                if ($(this).data('width')) {
                    width = $(this).data('width');
                }

                if ($(this).data('height')) {
                    height = $(this).data('height');
                }

                if ($(this).data('view-only')) {
                    view_only = $(this).data('view-only');
                }

                if ($(this).data('speech-to-text')) {
                    speech_to_text = $(this).data('speech-to-text');
                }

                if ($(this).data('field') === 'relationship') {
                    primary_column = $(this).attr('data-primary-column');
                    mappings = $(this).attr('data-mappings');
                    primary_keys = $(this).attr('data-primary-keys');
                    filter_column = $(this).attr('data-filter-column');
                    related_filter = $(this).attr('data-related-filter');
                    related_type = $(this).attr('data-related-type');
                    scanner = $(this).attr('data-scanner');
                }

                if ($(this).data('field') === 'alert') {
                    alert_type = $(this).attr('data-alert-type');
                    event_field = $(this).attr('data-alert-field');
                    event_option = $(this).attr('data-alert-option');
                }

                if ($(this).attr('data-option-colors')) {
                    color_options = $(this).attr('data-option-colors');
                }

                if ($(this).data('unique') && $(this).data('unique') != null) {
                    unique = $(this).data('unique')
                } else {
                    unique = 0
                }

                if ($(this).data('capital') && $(this).data('capital') != null) {
                    capital = $(this).data('capital')
                } else {
                    capital = 0
                }

                if ($(this).data('id') && $.trim($(this).data('id')).length) {
                    id = $(this).data('id')
                } else if ($(this).attr('data-id')) {
                    id = $(this).attr('data-id');
                } else {
                    id = '';
                }

                if ($(this).data('values') && $(this).data('values') != null) {
                    slVals = $(this).data('values')
                } else {
                    slVals = $(this).attr('data-values')
                }

                if ($(this).data('required') && $(this).data('required') != null) {
                    required = $(this).data('required')
                } else {
                    required = 0
                }

                if ($(this).data('nonzero') && $(this).data('nonzero') != null) {
                    nonzero = $(this).data('nonzero')
                } else {
                    nonzero = 0
                }

                if ($(this).data('default') && $(this).data('default') != null) {
                    defOpt = $(this).data('default')
                } else {
                    defOpt = 'no'
                }

                if ($(this).data('olabel') && $(this).data('olabel') != null) {
                    opLabel = $(this).data('olabel')
                } else {
                    opLabel = ''
                }

                if ($(this).data('value') && $(this).data('value') != null) {
                    opVal = $(this).data('value')
                } else {
                    opVal = ''
                }

                if ($(this).data('related') && $(this).data('related') != null) {
                    isRelated = $(this).data('related')
                } else {
                    isRelated = 0
                }

                if ($(this).data('relid') && $(this).data('relid') != null) {
                    relatedId = $(this).data('relid')
                } else {
                    relatedId = ''
                }

                if ($(this).data('pattern') && $(this).data('pattern') != null) {
                    pattern = $(this).data('pattern')
                } else {
                    pattern = '';
                    pattern_enabled = 0;
                }

                if ($(this).data('field') === 'autonumber') {
                    if ($(this).data('pattern-enabled')) {
                        pattern_enabled = 1;
                    } else {
                        pattern_enabled = 0;
                    }

                    if ($(this).data('auto-type')) {
                        auto_field_type = $(this).data('auto-type');
                    } else {
                        auto_field_type = 'alpha';
                    }
                }

                if ($(this).data('name') && $(this).data('name') != null) {
                    name = $(this).data('name')
                } else {
                    name = $(this).attr('data-name')
                }

                if ($(this).attr('data-relfields')) {
                    related_fields = $(this).attr('data-relfields');
                }

                if ($(this).data('label') && $(this).data('label') != null) {
                    label = String($(this).data('label')).trim();
                } else {
                    label = $(this).attr('data-label').trim();
                }

                if ($(this).data('field') === 'formula') {
                    opVal = $(this).attr('data-value');
                }

                if ($(this).data('field') === 'alert') {
                    opVal = $(this).attr('data-value');
                }

                if ($(this).data('field') === 'button') {
                    automation_id = $(this).attr('data-automation-id');
                    message = $(this).attr('data-message');
                    btn_color = $(this).attr('data-btn-color');
                    btn_text_color = $(this).attr('data-btn-text-color');
                }

                if ($(this).data('type') === 'multiselect' || $(this).data('type') === 'radio' || $(this).data('type') === 'multipleselect') {

                    let lblname = $(this).closest('.propsControl').find('.multipicklist_data').data('lblname');
                    let fieldname = $(this).closest('.propsControl').find('.multipicklist_data').data('fieldname');
                    if (lblname === 'undefined')
                        lblname = $(this).attr('data-lblname')

                    if (fieldname === 'undefined')
                        fieldname = $(this).attr('data-fieldname')

                    if (lblname == null && fieldname == null) {

                        let $fieldItem = $('.fieldsSection').find(`.fieldItem[name="${name}"]`);

                        if ($fieldItem.length > 1) {
                            showAlert(`Field name ${name} already exists`);
                            errors = true;
                        }

                        tableData.fields.push({
                            type: $(this).data('type'),
                            label: label,
                            name: name,
                            id: id,
                            order: $(this).data('order'),
                            fieldType: $(this).data('field'),
                            values: slVals,
                            value: opVal,
                            hidden: $(this).data('hidden'),
                            required: required,
                            nonzero: nonzero,
                            scanner: scanner,
                            unique: unique,
                            capital: capital,
                            hint: hint,
                            description: description,
                            default: defOpt,
                            optionLabel: opLabel,
                            isRelated: isRelated,
                            relatedId: relatedId,
                            pattern: pattern,
                            section: section,
                            primary_column: primary_column,
                            color_options: color_options,
                            mappings: mappings,
                            primary_keys: primary_keys,
                            related_type: related_type,
                            filter_column: filter_column,
                            related_filter: related_filter,
                            alert_type: alert_type,
                            event_field: event_field,
                            event_option: event_option,
                            height: height,
                            width: width,
                            view_only: view_only,
                            speech_to_text: speech_to_text,
                            pattern_enabled: pattern_enabled,
                            automation_id: automation_id,
                            btn_color: btn_color,
                            btn_text_color: btn_text_color,
                        })
                    } else {

                        let $fieldItem = $('.fieldsSection').find(`.fieldItem[name="${lblname}"]`);

                        if ($fieldItem.length > 1) {
                            showAlert(`Field name ${lblname} already exists`);
                            errors = true;
                        }

                        tableData.fields.push({
                            type: $(this).data('type'),
                            label: lblname,
                            name: fieldname,
                            id: id,
                            order: $(this).data('order'),
                            fieldType: $(this).data('field'),
                            values: slVals,
                            value: opVal,
                            hidden: $(this).data('hidden'),
                            required: required,
                            nonzero: nonzero,
                            scanner: scanner,
                            unique: unique,
                            capital: capital,
                            hint: hint,
                            description: description,
                            default: defOpt,
                            optionLabel: opLabel,
                            isRelated: isRelated,
                            relatedId: relatedId,
                            pattern: pattern,
                            section: section,
                            primary_column: primary_column,
                            related_type: related_type,
                            color_options: color_options,
                            mappings: mappings,
                            primary_keys: primary_keys,
                            filter_column: filter_column,
                            related_filter: related_filter,
                            alert_type: alert_type,
                            event_field: event_field,
                            event_option: event_option,
                            height: height,
                            width: width,
                            view_only: view_only,
                            speech_to_text: speech_to_text,
                            pattern_enabled: pattern_enabled,
                            automation_id: automation_id,
                            message: message,
                            btn_color: btn_color,
                            btn_text_color: btn_text_color,
                        })
                    }
                } else {
                    if ($(this).data('type') == 'text' ||
                        $(this).data('type') == 'search' ||
                        $(this).data('type') == 'date' ||
                        $(this).data('type') == 'email' ||
                        $(this).data('type') == 'textarea' ||
                        $(this).data('type') == 'url'
                    ) {
                        tableData.fields.push({
                            type: $(this).data('type'),
                            label: label,
                            name: name,
                            id: id,
                            order: $(this).data('order'),
                            fieldType: $(this).data('field'),
                            // values: slVals,
                            value: opVal,
                            hidden: $(this).data('hidden'),
                            required: required,
                            nonzero: nonzero,
                            scanner: scanner,
                            unique: unique,
                            capital: capital,
                            hint: hint,
                            description: description,
                            related_fields: related_fields,
                            default: defOpt,
                            optionLabel: opLabel,
                            isRelated: isRelated,
                            relatedId: relatedId,
                            pattern: pattern,
                            section: section,
                            primary_column: primary_column,
                            related_type: related_type,
                            color_options: color_options,
                            mappings: mappings,
                            primary_keys: primary_keys,
                            filter_column: filter_column,
                            related_filter: related_filter,
                            alert_type: alert_type,
                            event_field: event_field,
                            event_option: event_option,
                            height: height,
                            width: width,
                            view_only: view_only,
                            speech_to_text: speech_to_text,
                            pattern_enabled: pattern_enabled,
                            auto_field_type: auto_field_type,
                            automation_id: automation_id,
                            message: message,
                            btn_color: btn_color,
                            btn_text_color: btn_text_color,
                        })
                    } else {
                        tableData.fields.push({
                            type: $(this).data('type'),
                            label: label,
                            name: name,
                            id: id,
                            order: $(this).data('order'),
                            fieldType: $(this).data('field'),
                            values: slVals,
                            value: opVal,
                            hidden: $(this).data('hidden'),
                            required: required,
                            nonzero: nonzero,
                            scanner: scanner,
                            unique: unique,
                            capital: capital,
                            hint: hint,
                            description: description,
                            default: defOpt,
                            optionLabel: opLabel,
                            related_fields: related_fields,
                            isRelated: isRelated,
                            relatedId: relatedId,
                            pattern: pattern,
                            section: section,
                            primary_column: primary_column,
                            related_type: related_type,
                            color_options: color_options,
                            mappings: mappings,
                            primary_keys: primary_keys,
                            filter_column: filter_column,
                            related_filter: related_filter,
                            alert_type: alert_type,
                            event_field: event_field,
                            event_option: event_option,
                            height: height,
                            width: width,
                            view_only: view_only,
                            speech_to_text: speech_to_text,
                            pattern_enabled: pattern_enabled,
                            auto_field_type: auto_field_type,
                            automation_id: automation_id,
                            message: message,
                            btn_color: btn_color,
                            btn_text_color: btn_text_color,
                        })
                    }
                }
            }
        });

        // console.log(tableData.sections);
        // console.log(tableData.fields);

        if (errors) {
            return;
        }

        tableData.fields = JSON.stringify(tableData.fields);
        tableData.sections = JSON.stringify(tableData.sections);

        $.ajax({
            url: `${window.location.href}`,
            type: 'POST',
            data: tableData,
            success: function (data) {
                if (data.saved) {
                    let newFields = $.parseJSON(data.data),
                        newSection = $.parseJSON(data.new_sections);
                    $.each(newFields, function () {
                        let data = {
                            'data-id': this.id,
                            'data-label': this.label,
                            'data-name': this.name
                        };
                        $('.fieldItem[data-name="' + this.name + '"]').attr(data)
                            .data('id', this.id)
                            .data('label', this.label)
                            .data('name', this.name);
                    });
                    $.each(newSection, function () {
                        let data = {
                            'data-section-id': this.id,
                            'data-section-label': this.label,
                            'data-section-name': this.name
                        };
                        $('.fieldsSection[data-section-order="' + this.order + '"]').attr(data)
                            .data('section-id', this.id)
                            .data('section-name', this.name)
                            .data('section-label', this.label);
                    });
                    $('body').find('.sectionName').attr('readonly', true);
                    $('.propsField[data-field="name"]').attr('readonly', true);
                    $('.auto-pattern-holder').addClass('d-none');
                    $('.auto-field-type').attr('disabled', true);
                    sectionManager.updateAttributes();
                    showAlert(data.message, 'alert-success');

                    if (typeof currentItem.data('url') != 'undefined' && currentItem.data('url') != '') {
                        console.log(currentItem.data('url'))
                        window.location.href = currentItem.data('url')
                    }
                }
            },
            error: function (xhr, status, error) {
                let res = xhr.responseJSON;
                showAlert(res.message, 'alert-danger');
            }
        })
    })
});

function showAlert(message, type) {
    if (type === 'alert-success') {
        toastr.success(message);
    } else {
        toastr.error(message);
    }
}
